/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Searchitemtitle2Inputs */

const id_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari`)
};

const ms_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari`)
};

const da_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg`)
};

const de_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche`)
};

const en_us2_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const es_es2_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const es_mx2_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const fil_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap`)
};

const fr_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher`)
};

const it_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const hu_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keresés`)
};

const nl_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoeken`)
};

const no_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk`)
};

const pl_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj`)
};

const pt_br2_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procurar`)
};

const pt_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar`)
};

const ro_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Căutare`)
};

const fi_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae`)
};

const sv_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök`)
};

const vi_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm`)
};

const tr_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ara`)
};

const cs_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat`)
};

const bg_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене`)
};

const ru_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск`)
};

const uk_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук`)
};

const ar_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بحث`)
};

const hi_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोज`)
};

const th_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหา`)
};

const ja_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索`)
};

const zh_cn2_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索`)
};

const zh_hant1_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋`)
};

const ko_nav_searchitemtitle2 = /** @type {(inputs: Nav_Searchitemtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Nav_Searchitemtitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_searchitemtitle2 = /** @type {((inputs?: Nav_Searchitemtitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Searchitemtitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_searchitemtitle2(inputs)
	if (locale === "ms") return ms_nav_searchitemtitle2(inputs)
	if (locale === "da") return da_nav_searchitemtitle2(inputs)
	if (locale === "de") return de_nav_searchitemtitle2(inputs)
	if (locale === "en-US") return en_us2_nav_searchitemtitle2(inputs)
	if (locale === "es-ES") return es_es2_nav_searchitemtitle2(inputs)
	if (locale === "es-MX") return es_mx2_nav_searchitemtitle2(inputs)
	if (locale === "fil") return fil_nav_searchitemtitle2(inputs)
	if (locale === "fr") return fr_nav_searchitemtitle2(inputs)
	if (locale === "it") return it_nav_searchitemtitle2(inputs)
	if (locale === "hu") return hu_nav_searchitemtitle2(inputs)
	if (locale === "nl") return nl_nav_searchitemtitle2(inputs)
	if (locale === "no") return no_nav_searchitemtitle2(inputs)
	if (locale === "pl") return pl_nav_searchitemtitle2(inputs)
	if (locale === "pt-BR") return pt_br2_nav_searchitemtitle2(inputs)
	if (locale === "pt") return pt_nav_searchitemtitle2(inputs)
	if (locale === "ro") return ro_nav_searchitemtitle2(inputs)
	if (locale === "fi") return fi_nav_searchitemtitle2(inputs)
	if (locale === "sv") return sv_nav_searchitemtitle2(inputs)
	if (locale === "vi") return vi_nav_searchitemtitle2(inputs)
	if (locale === "tr") return tr_nav_searchitemtitle2(inputs)
	if (locale === "cs") return cs_nav_searchitemtitle2(inputs)
	if (locale === "bg") return bg_nav_searchitemtitle2(inputs)
	if (locale === "ru") return ru_nav_searchitemtitle2(inputs)
	if (locale === "uk") return uk_nav_searchitemtitle2(inputs)
	if (locale === "ar") return ar_nav_searchitemtitle2(inputs)
	if (locale === "hi") return hi_nav_searchitemtitle2(inputs)
	if (locale === "th") return th_nav_searchitemtitle2(inputs)
	if (locale === "ja") return ja_nav_searchitemtitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_searchitemtitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_searchitemtitle2(inputs)
	return ko_nav_searchitemtitle2(inputs)
});
export { nav_searchitemtitle2 as "nav.searchItemTitle" }